import { useContext, useMemo, useState } from "react";
import { useTable } from "react-table";
import { defaultDateDisplay } from "../../../../helpers";
import primaryComponents from "../../../primaryComponents";
import { DeleteIcon } from "../../../../assets/svgIcons";
import "../../../../assets/styles/base/globalPage.scss";
import { useDeletePOCategoryMutation } from "../../../../hooks/api/mutations";
import { ToastContext } from "../../../../hooks/context";

export const usePOCategoriesTable = ({ pOCategories }) => {
  const [isDeletePOCategory, setIsDeletePOCategory] = useState(null);
  const [isUpdatePOCategory, setIsUpdaePOCategory] = useState(null);
  const triggerToast = useContext(ToastContext);

  const columns = useMemo(
    () => [
      {
        Header: "Created At",
        accessor: "created_at",
        Cell: ({ cell: { value } }) =>
          value ? defaultDateDisplay(value) : "N/A",
      },
      {
        Header: "Name",
        accessor: "name",
      },

      {
        Header: "Actions",
        Cell: ({ row }) => (
          <span className="d-flex align-items-center" style={{ gap: "10px" }}>
            <primaryComponents.Button
              className="btn btn--primary smallBtn"
              onClick={() => {
                setIsUpdaePOCategory(row?.original);
              }}
            >
              Update
            </primaryComponents.Button>

            <span
              className="cursor-pointer"
              onClick={() => setIsDeletePOCategory(row?.original)}
            >
              <DeleteIcon />
            </span>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({
    columns,
    data: pOCategories || [],
  });

  const { mutate: updateCategory, isLoading: isDeleting } =
    useDeletePOCategoryMutation();

  const handleDeleteCategory = (id) => {
    updateCategory(
      { id: isDeletePOCategory?.id },
      {
        onSuccess: () => {
          triggerToast("PO category deleted successfully", "success");
          setIsDeletePOCategory(null);
        },
      },
    );
  };

  return {
    instance,
    isDeleting,
    isDeletePOCategory,
    isUpdatePOCategory,
    setIsUpdaePOCategory,
    setIsDeletePOCategory,
    handleDeleteCategory,
  };
};
